import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { twMerge } from '../../utils/twMerge.js';
import { Text } from '../Text/Text.js';
/**
 * The `<Strong>` component is for content that is of "strong importance," including things of great seriousness or
 * urgency (such as warnings). This could be a sentence that is of great importance to the whole page, or you could
 * merely try to point out that some words are of greater importance compared to nearby content.
 *
 * This element is rendered by default using a bold font weight. However, it should not be used to apply bold styling;
 * use CSS styling for that purpose.
 */
export const Strong = forwardRef(function Strong(props, forwardedRef) {
    return (_jsx(Text, { ...props, ref: forwardedRef, elementType: "strong", className: twMerge('font-medium', props.className) }));
});
//# sourceMappingURL=Strong.js.map